export default "__VITE_ASSET__BzyybbTa__"